import { CommmuneJwt } from '../../types'
import { printError } from '../log'
import { callAPI } from './common'

export const fetchCommmuneJwt = async () => {
  try {
    const token = await callAPI<CommmuneJwt>('/api/users/commmune_login', {
      method: 'POST',
    })
    return token
  } catch (e) {
    printError(e)
    return null
  }
}
